import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class GeneralInquiry {
  constructor(init) {
    if (isNil(init)) return undefined
    this._employee_id = init.employee_id
    this._organization_name = init.organization_name
    this._request_details = init.request_details
    this._user_email = init.user_email
    this._user_name = init.user_name
    this._user_phone_number = init.user_phone_number
    this._users_job_title = init.users_job_title
    this._contact_method_type = init.contact_method_type
    this._contact_method_value = init.contact_method_value
  }

  static shape = {
    employee_id: PropTypes.string,
    organization_name: PropTypes.string,
    request_details: PropTypes.string,
    user_email: PropTypes.string,
    user_name: PropTypes.string,
    user_phone_number: PropTypes.string,
    users_job_title: PropTypes.string,
    contact_method_type: PropTypes.string,
    contact_method_value: PropTypes.string
  }

  get employee_id() {
    return this._employee_id
  }

  get organization_name() {
    return this._organization_name
  }

  get request_details() {
    return this._request_details
  }

  get user_email() {
    return this._user_email
  }

  get user_name() {
    return this._user_name
  }

  get user_phone_number() {
    return this._user_phone_number
  }

  get users_job_title() {
    return this._users_job_title
  }

  get contact_method_type() {
    return this._contact_method_type
  }

  get contact_method_value() {
    return this._contact_method_value
  }
}

export default GeneralInquiry
